import { useEffect, useState } from 'react';
import { api } from '../api/client';
import { Empty, Skeleton } from './ui.jsx';
import { t, fmtDate } from '../i18n/index.jsx';

function formatWhen(iso) {
  if (!iso) return '—';
  const d = String(iso).slice(0, 10);
  const time = String(iso).length > 10 ? String(iso).slice(11, 16) : '';
  return time ? `${fmtDate(d)} ${time}` : fmtDate(d);
}

function actionLabel(action) {
  const map = {
    create: t('Created'),
    update: t('Updated'),
    delete: t('Deleted'),
    status: t('Status changed'),
    bulk_update: t('Bulk update'),
  };
  return map[action] || action;
}

export default function ActivityFeed({ entityType, entityId, title, limit = 20, compact = false }) {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    if (!entityType || !entityId) return;
    let cancelled = false;
    setRows(null);
    api.get(`/activity?entity_type=${encodeURIComponent(entityType)}&entity_id=${entityId}&limit=${limit}`)
      .then((r) => { if (!cancelled) setRows(r.data || []); })
      .catch(() => { if (!cancelled) setRows([]); });
    return () => { cancelled = true; };
  }, [entityType, entityId, limit]);

  const body = rows == null ? (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {[0, 1, 2].map((i) => <Skeleton key={i} height={14} width={`${70 - i * 10}%`} />)}
    </div>
  ) : rows.length === 0 ? (
    <Empty>{t('No activity yet.')}</Empty>
  ) : (
    <ul className={`activity-list ${compact ? 'compact' : ''}`}>
      {rows.map((a) => (
        <li key={a.id}>
          <div className="activity-main">
            <span className="activity-action">{actionLabel(a.action)}</span>
            {a.detail && <span className="activity-detail muted">{a.detail}</span>}
          </div>
          <div className="activity-meta muted sm">
            <span>{a.user_name || t('System')}</span>
            <span>·</span>
            <span>{formatWhen(a.created_at)}</span>
          </div>
        </li>
      ))}
    </ul>
  );

  if (compact) {
    return (
      <div className="activity-feed compact">
        <div className="field-label" style={{ marginBottom: 8 }}>{title || t('Activity')}</div>
        {body}
      </div>
    );
  }

  return (
    <section className="panel activity-feed">
      <h2 className="panel-title">{title || t('Activity')}</h2>
      {body}
    </section>
  );
}
